import { useSelector } from 'react-redux';
import cn from 'classnames';

import { useGilt, useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectCurrentSalonAllowanceYear, selectCurrentSalonAllowanceYearStart } from 'selectors/currentSalon.selectors';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { formatDayToYearOrdinal } from 'utils/date/format.util';
import parseDate from 'utils/parsers/parseDate';
import c from 'utils/values/constant.util';

import CN from './FilterReports.module.scss';

const TIME_OFF_YEAR_RANGE = c({
  taxYear: 'Tax Year',
  calendarYear: 'Calendar Year',
  customYear: 'Custom',
});

export const FilterReports = ({ children }) => {
  const { isDarkMode } = useTheme();
  const { isSalonInGB } = useGilt();
  const { t } = useTranslation();

  const allowanceYear = useSelector(selectCurrentSalonAllowanceYear);
  const allowanceYearStart = useSelector(selectCurrentSalonAllowanceYearStart);

  const currentYear = new Date().getFullYear();
  const nextYear = new Date().getFullYear() + 1;

  const displayTaxYear = t('staffKpisReports.reportsTimeOff.taxYearPeriod', { currentYear, nextYear });
  const displayCalendarYear = t('staffKpisReports.reportsTimeOff.calendarYearPeriod', { year: currentYear });
  // TODO: extracted in src/utils and/or src/bl and add some tests
  const allowanceYearEnd = new Date(parseDate(allowanceYearStart));
  allowanceYearEnd.setDate(allowanceYearEnd.getDate() + 365);

  const allowanceYearEndString = fromAnyToString(allowanceYearEnd);

  const displayCustomYear = `${formatDayToYearOrdinal(allowanceYearStart)} - ${formatDayToYearOrdinal(allowanceYearEndString)}`;

  const DATA_MAP = {
    [TIME_OFF_YEAR_RANGE.calendarYear]: displayCalendarYear,
    [TIME_OFF_YEAR_RANGE.customYear]: displayCustomYear,
  };
  if (isSalonInGB) DATA_MAP[TIME_OFF_YEAR_RANGE.taxYear] = displayTaxYear;

  const renderedData = DATA_MAP[allowanceYear];

  return (
    <div
      data-bem="FilterReports"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <span className={CN.title}>{renderedData}</span>
      <div className={CN.flex}>{children}</div>
    </div>
  );
};
